import { extendTheme } from "@mui/joy/styles";

export const appTheme = extendTheme({
  radius: {
    sm: "6px",
    md: "8px",
    lg: "12px",
  },
  shadow: {
    sm: "0 1px 3px rgba(0,0,0,0.08)",
    md: "0 2px 8px rgba(0,0,0,0.12)",
    lg: "0 6px 18px rgba(0,0,0,0.16)",
  },
  colorSchemes: {
    light: {
      palette: {
        background: {
          body: "#f0f1f3",
          surface: "#f7f7f8",
        },
        text: {
          primary: "#1d1f22",
          secondary: "#4a4f55",
          tertiary: "#6b7077",
        },
        primary: {
          500: "#1d1f22",
          600: "#141517",
          700: "#0b0c0d",
        },
        neutral: {
          50: "#f3f3f4",
          100: "#e7e7e9",
          200: "#dadbdd",
          600: "#555b62",
          700: "#3f4349",
          800: "#2a2d31",
          900: "#121416",
        },
        warning: {
          500: "#f0c04a",
          600: "#d7a52c",
        },
      },
    },
  },
});

export const textStyles = {
  title: {
    color: "text.primary",
    fontWeight: 600,
  },
  micro: {
    fontSize: "0.75rem",
    color: "text.tertiary",
  },
  metaInline: {
    fontSize: "0.7em",
    color: "text.secondary",
    fontWeight: "normal",
  },
  meta: {
    fontSize: "0.8em",
    color: "text.secondary",
  },
  badge: {
    backgroundColor: "neutral.100",
    padding: "2px 8px",
    borderRadius: "4px",
    fontSize: "0.85em",
  },
  badgeDanger: {
    color: "danger.600",
    fontWeight: "bold",
    fontSize: "0.85em",
    padding: "2px 8px",
    borderRadius: "4px",
    backgroundColor: "danger.softBg",
  },
};

export const iconCtaSx = {
  color: "neutral.900",
  "& svg": { color: "inherit" },
  "&:hover": {
    color: "neutral.900",
    backgroundColor: "neutral.softBg",
    "& svg": { color: "inherit" },
  },
};

export const iconCtaSxOnDark = {
  color: "neutral.100",
  "& svg": { color: "inherit" },
  "&:hover": {
    color: "neutral.100",
    backgroundColor: "neutral.800",
    "& svg": { color: "inherit" },
  },
};

export const globalStyles = {
  "*, *::before, *::after": {
    boxSizing: "border-box",
  },
  "html, body, #root": {
    height: "100%",
    width: "100%",
    margin: 0,
    padding: 0,
  },
  body: {
    overflow: "hidden",
  },
};
